import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals'

import { isProd } from '~/env'
import { logger } from './logger'

/**
 * Subscribe to Web Vitals and forward each metric as a Sentry breadcrumb.
 * No-op in dev so we don't pollute Sentry while developing.
 *
 * Targets (from the plan): LCP p75 ≤ 2.0s, INP p75 ≤ 200ms, CLS ≤ 0.1.
 */
export function initWebVitals(): void {
  if (!isProd) return
  onCLS(report)
  onLCP(report)
  onINP(report)
  onFCP(report)
  onTTFB(report)
}

function report(metric: Metric): void {
  logger.info(`web-vitals:${metric.name}`, {
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    navigationType: metric.navigationType,
  })
}
